import { batch } from "react-redux";
import moment from "moment";
import {
  setCompanyData,
  setProjectDetail,
  setAppError,
  setDataSettings,
  runCompanyDataValidation,
} from "../../store/modules/appState/actions";
import { generateSDEAnalysis, generateHDEAnalysis } from "../../store/modules/qualityOfEarnings/actions";
import { generateBizminerRatios, updateBizminerRatios } from "../../store/modules/financialRatios/actions";
import { generateForecastedRevenue, generateForecastedDOE } from "../../store/modules/valuation/actions";
import { generateForecastRC } from "../../store/modules/forecastRC/actions";
import { generateForecastedGWC } from "../../store/modules/forecastGWC/actions";
import { generateForecastMaintenanceAndGrowthCapex } from "../../store/modules/forecastMGC/actions";
import { generateForecastedDepreciation } from "../../store/modules/forecastDepreciation/actions";
import { generateCapitalizationRate } from "../../store/modules/capitalizationRate/actions";
import { generateGrowthForecastStageDCF } from "../../store/modules/growthForecastStageDCF/actions";
import { setCategoryData } from "../../store/modules/category/actions";
import {
  fetchCompanyBalanceSheet,
  fetchCompanyMonthlyBalanceSheet,
  fetchCompanyMonthlyProfitAndLoss,
  // fetchCompanyProfitAndLoss,
} from "../../store/modules/financials/actions";
import FinancialHandler from '../../handlers/FinancialHandler';
import { store } from "../../store";
import { setStore } from "../../store/actions";

export const handleActivateProject = (projectId) => async (dispatch) => {
  //this function gets a saved project
  await FinancialHandler.saveProjectData();

  let newState = await FinancialHandler.fetchProjectData({ projectId });
  const averageEmployees = newState.financialRatios?.averageEmployees;
  //build the model from accounting database with category selection and data range (same as creating a new)
  await dispatch(setCategoryData(newState.category?.categorySelection)); //dispatch category for correct build
  await dispatch(handleBuildProject({
    startDate: moment.utc(newState.appState.dataSettings.startDate),
    endDate: moment.utc(newState.appState.dataSettings.endDate),
    company: newState.appState.companyData,
    form: {
      projectName: newState.appState.projectDetail.projectName,
      description: newState.appState.projectDetail.description
    }
  }));

  if(!newState.financials) return;   //when the project in database is fresh new, then there is no need for below
  const state = store.getState();   //get state
  delete newState.userId;
  delete newState.companyId;
  newState.user = state.user;
  newState.taxes = state.taxes;
  newState.reports = state.reports;
  newState.financials.companyBalanceSheetsReports = state.financials.companyBalanceSheetsReports;
  newState.financials.companyProfitAndLossReports = state.financials.companyProfitAndLossReports;
  newState.financials.currentCompanyMonthlyBalanceSheet = state.financials.currentCompanyMonthlyBalanceSheet;
  newState.financials.currentCompanyMonthlyProfitAndLoss = state.financials.currentCompanyMonthlyProfitAndLoss;
  newState.financials.companyBalanceSheetsReports = state.financials.companyBalanceSheetsReports;
  newState.financialRatios = state.financialRatios;
  newState.financialRatios.currentCompanyBizminerRatios = { averageEmployees };

  await dispatch(setStore(newState));
};

export const handleBuildProject = ({
  startDate,
  endDate,
  company,
  form
}) => async (dispatch) => {
  //this function fetches financial data from database and build a new project. It keeps original categorys.
  const startMonth = startDate.format("YYYY-MM-01");
  const endMonth = endDate.endOf('month').format("YYYY-MM-DD");

  dispatch(setDataSettings({ startDate, endDate }));

  try {
    await dispatch(fetchCompanyMonthlyBalanceSheet(
      { companyId: company?.id },
      { startMonth, endMonth },
      { clearCache: true }
    ));
    await dispatch(fetchCompanyBalanceSheet({ companyId: company?.id }, { startMonth, endMonth }));

    await dispatch(fetchCompanyMonthlyProfitAndLoss(
      { companyId: company?.id },
      { startMonth, endMonth },
      { clearCache: true }
    ));
    // It is proved that this is not needed
    // await dispatch(fetchCompanyProfitAndLoss({ companyId: company?.id }, { startMonth, endMonth }));

    await dispatch(generateSDEAnalysis({ clearCache: true }));
    await dispatch(generateHDEAnalysis({ clearCache: true }));
    await dispatch(generateBizminerRatios({ clearCache: true }));
    await dispatch(generateForecastedRevenue({ clearCache: true }));
    await dispatch(generateForecastedDOE({ clearCache: true }));
    if (true) {    //handle this part for keep settings(original: company?.id !== appState.companyData.id)
      await dispatch(generateForecastRC({ clearCache: true }));
      await dispatch(generateForecastedGWC({ clearCache: true }));
      await dispatch(generateForecastMaintenanceAndGrowthCapex({ clearCache: true }));
      await dispatch(generateForecastedDepreciation({ clearCache: true }));
      await dispatch(generateCapitalizationRate({ clearCache: true }));
      await dispatch(generateGrowthForecastStageDCF({ clearCache: true }));
      //add 3 more pages in the bottom of valuation tab and other tabs
    }
    await dispatch(setAppError({ state: false, message: null }));

    await dispatch(setProjectDetail({
      projectName: form.projectName,
      description: form.description,
      startAt: startMonth,
      endAt: endMonth
    }));
    await dispatch(setCompanyData(company));
  } catch (e) {
    batch(() => {
      dispatch(setAppError({ state: true, message: e }));
    });
  }

  dispatch(runCompanyDataValidation());
};
